import { FC, useEffect, useState } from "react";
import PolicyItem from "components/PrivacyPolicyListing/PolicyItem";
import Seo from "components/Seo/Seo";
import { getAllPrivacyPolicySections } from "services/api";
import { IPrivacyPolicySection } from "services/models/index";

const PrivacyPolicyPage: FC<any> = () => {
  const [sections, setSections] = useState<IPrivacyPolicySection[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getAllPrivacyPolicySections()
      .then((data: any) => {
        setSections(data);
        setLoading(false);
      })
      .catch((err: any) => {
        setError("Failed to fetch About Us sections");
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }
  // Sort sections by order
  sections.sort((a, b) => (a.order || 0) - (b.order || 0));
  // Map sections to the existing texts structure
  const texts = sections.map((section) => ({
    title: section.title,
    text: section.text,
    icon: "exclamation-circle",
  }));

  return (
    <div
      className={`nc-PagePrivacyPolicy overflow-hidden relative`}
      data-nc-id="PagePrivacyPolicy"
    >
      <Seo
        name="Privacy Policy | Orbito Travel"
        description="Review Orbito Travel's privacy policy for peace of mind while exploring accessible travel options. Learn how we safeguard your information and prioritize data security. Trust in our commitment to transparency and your privacy as you embark on your journey with us."
        title="Privacy Policy | Orbito Travel"
        type="page"
      />
      <div className="container py-16 space-y-16 lg:space-y-28">
        <div className="w-screen max-w-full">
          <h2 className="text-3xl !leading-tight font-semibold text-neutral-900 md:text-4xl xl:text-5xl dark:text-neutral-100 mb-8">
            Privacy Policy
          </h2>
          <div className="block text-base xl:text-lg text-neutral-6000 dark:text-neutral-400">
            <PolicyItem texts={texts} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
